function Insurance() {
  return (
    <div>
      <span>مبنای محاسبه بیمه: </span>
      <span>10,000 ریال</span>
      <span> + </span>
      <span>(ارزش کالا × 0/002)</span>
    </div>
  );
}

export default Insurance;
